import BaseDocumentHead, { IDocumentHead } from 'components/DocumentHead'
import { MALE } from 'constants/gender'
import TrackContentPageView from 'helpers/tracking/trackerComponents/TrackContentPageView'
import { inject } from 'mobx-react'
import { getContentTypeFilters } from 'pages/StoryOverview/helpers'
import React, { FC } from 'react'
import { IStoreProvider } from 'store'

const DocumentHead: FC<Partial<IDocumentHead>> = props => {
  return (
    <>
      <TrackContentPageView pageTitle={props.title || ''} />
      <BaseDocumentHead {...props} />
    </>
  )
}

export default inject((store: IStoreProvider) => {
  const { t } = store
  const { gender } = store.userStore
  const { params } = store.urlManagerStore

  const title =
    gender === MALE
      ? t('Angesagte Modetrends und Outfits für Herren')
      : t('Angesagte Modetrends und Outfits für Damen')
  const metaDescription =
    gender === MALE
      ? t(
          'Du interessierst dich für die aktuellsten Modetrends für Herren oder bist auf der Suche nach einem coolen Outfit? Die Stories von ABOUT YOU helfen dir weiter!',
        )
      : t(
          'Du interessierst dich für die aktuellsten Modetrends für Damen oder bist auf der Suche nach einem coolen Outfit? Die Stories von ABOUT YOU helfen dir weiter!',
        )

  const hasSeoRelevantFilters = !!getContentTypeFilters(params).length
  const robotsMeta = hasSeoRelevantFilters ? 'noindex,follow' : 'index,follow'

  return {
    title,
    description: metaDescription,
    robots: robotsMeta,
    renderHreflangs: !hasSeoRelevantFilters,
    allowEmptyHreflangs: false,
  }
})(DocumentHead)
